import en from './en'
import zh from './zh'

export default {
  en: en,
  zh: zh,
}


// WEBPACK FOOTER //
// ./src/international/index.js